// import axios from "../../../core/api/http-common";

// Classmates
const ON_GET_CLASSMATES = "/users/get/student/classmates";
export function onGetClassmates(axiosPrivate, data, signal) {
  const _data = {
    inscription_id: data?.inscription_id,
    stream_id: data?.stream_id,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .get(ON_GET_CLASSMATES, { params: _data, signal: signal })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
